import React from 'react';

import { ModelContextProvider } from '@contexts/ModelContext';

import ModelsSelectorWrapper from '@components/ContactsSelector/ModelsSelector/ModelsSelectorWrapper';

/**
 * Selettore modelle per l'aggiunta a una folder, da aprire in un drawer.
 * Il ModelContext dedicato serve a partire sempre da "all models": ereditando quello
 * esterno il selettore aprirebbe sulla folder corrente, mostrando solo chi c'e' gia'.
 */
const FolderAddModels = ({ folderID }) => {
    return (
        <ModelContextProvider listTypeSelected="all" activeSetSelected="all">
            <ModelsSelectorWrapper
                currentFolderID={folderID}
                defaultView="table"
                disabledModelAvailability
                fixedView
                isDrawer
                layouttype="fullpage"
                itemClickAction="preview-drawer"
                scope="folder"
            />
        </ModelContextProvider>
    );
};

export default FolderAddModels;
